import { fetchSinToken } from "../../helpers/fetch";

export const newPasswordService = (email, codigo, password) => {
    return async (dispatch) => {

        const resp = await fetchSinToken('/api/auth/newpass', { "email": email, "codigo": codigo, "password": password }, 'POST');
        const body = await resp.json();
        console.log(body);
        console.log("validando fetch");

        if (body.errors == null) {
            console.log(body);
            console.log("EXITOSO");
            dispatch({
                type: 'SUCCESS',
                payload: body,
            });
        } else {
            console.log("ERROR");
            dispatch({
                type: 'FAILURE',
                payload: body.errors || 'Error sending email',
            });
            throw new Error(body.errors || 'Error sending email');
        }
    }

}

